import { render } from "./Category.vue?vue&type=template&id=335c93df&scoped=true&ts=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=335c93df&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335c93df"]])

export default __exports__